module.exports = __webpack_public_path__ + "media/images/default/shared/up-arrow-6f901c318d773b182188a7f09f0120d2.svg";